module.exports = __webpack_public_path__ + "img/icon-warning-ani.9968881b.gif";